export const initialState = {
  status: null,
  surveyId: null,
  questions: [],
  currentQuestionId: null,
  isModalOpen: false,
  isStatusLoaded: false,
  actionProcessing: false,
};
